import type { AxiosRequestConfig } from 'axios';

/**
 * Meant to be used by functions that have built-in retry logic to indicate
 * non-retryable errors. We shouldn't do empty returns in these cases, because
 * the function won't reject when encountering such an error.
 */
export default class ApiNonRetryableResponseError extends Error {
  public name = 'ApiNonRetryableResponseError';
  public method: AxiosRequestConfig['method'];

  constructor({ method }: { method: AxiosRequestConfig['method'] }) {
    // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    super(method);
    Object.setPrototypeOf(this, new.target.prototype);

    this.message = method ?? this.name;
    this.method = method;
  }
}
